import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import BreadcrumbDetailed from "components/Common/BreadcrumbDetailed";
import Feedback from "./FeedBack";
import { getContactReasonList, resetSearch } from "redux/actions";
import { getLocalStorageValue } from 'config/helper';

const ContactUs = () => {
  const storeList = useSelector(({ store }) => store.storeListData);
  const dispatch = useDispatch();
  const isUserLoggedIn = useSelector(({ user }) => user.isUserLoggedIn);
  const { currentStoreID } = useSelector(({ store }) => store);
  const storeId = currentStoreID || getLocalStorageValue("selected-store-id");
  const clientId = getLocalStorageValue("RSAclient-id");
  const userToken = getLocalStorageValue("user-token");
  const memberNumber = getLocalStorageValue("member-number");
  const breadcrumbList = [{ lable: "Contact", link: "", searchTag: "" }];
  const contactReasonList = useSelector(
    ({ contactus }) => contactus.contactReasonList
  );

  useEffect(() => {
    dispatch(resetSearch());
  }, []); // eslint-disable-line

  useEffect(() => {
    const body = {
      RSAClientId: clientId,
      ClientStoreId: +storeId || 1,
      AppName: isUserLoggedIn ? "shop" : "",
      member_number: isUserLoggedIn ? memberNumber : "",
      user_token: isUserLoggedIn ? userToken : "",
      Version: isUserLoggedIn ? "1" : "",
      DeviceType: isUserLoggedIn ? "web" : "",
    };
    !contactReasonList.length && dispatch(getContactReasonList(body));
  }, [dispatch, storeId]); // eslint-disable-line

  return (
    <>
      <BreadcrumbDetailed
        breadcrumbList={breadcrumbList}
        title={"Contact"} //Need to pass title through api res
      />

      <Feedback storeList={storeList} />
    </>
  );
};
export default ContactUs;
